import type { SiteArrivalConfirmationStep } from './siteArrivalConfirmationTypes';

export function stepQuestionKey(stepId: SiteArrivalConfirmationStep): string {
  return `submitDocuments.siteArrivalConfirmation.steps.${stepId}`;
}

export function travelReceiptBubbleText(t: (k: string) => string): string {
  return [
    t('submitDocuments.siteArrivalConfirmation.travelReceiptLine1'),
    t('submitDocuments.siteArrivalConfirmation.travelReceiptLine2'),
    t('submitDocuments.siteArrivalConfirmation.travelReceiptLine3'),
    '',
    t('submitDocuments.siteArrivalConfirmation.travelReceiptPrompt'),
  ].join('\n');
}

export function dormRulesBubbleText(t: (k: string) => string): string {
  return [
    t('submitDocuments.siteArrivalConfirmation.dormRulesTitle'),
    t('submitDocuments.siteArrivalConfirmation.dormRule1'),
    t('submitDocuments.siteArrivalConfirmation.dormRule2'),
    t('submitDocuments.siteArrivalConfirmation.dormRule3'),
    t('submitDocuments.siteArrivalConfirmation.dormRule4'),
    '',
    t('submitDocuments.siteArrivalConfirmation.dormRulesPrompt'),
  ].join('\n');
}

export function mealRulesBubbleText(t: (k: string) => string): string {
  return [
    t('submitDocuments.siteArrivalConfirmation.mealRulesTitle'),
    t('submitDocuments.siteArrivalConfirmation.mealRule1'),
    t('submitDocuments.siteArrivalConfirmation.mealRule2'),
    t('submitDocuments.siteArrivalConfirmation.mealRule3'),
    '',
    t('submitDocuments.siteArrivalConfirmation.mealRulesPrompt'),
  ].join('\n');
}

export function mealIntroBubbleText(t: (k: string) => string): string {
  return [
    t('submitDocuments.siteArrivalConfirmation.mealIntroLine1'),
    t('submitDocuments.siteArrivalConfirmation.mealIntroLine2'),
  ].join('\n');
}
